<div :class="classes">
    <!-- Confirm reception -->
    <template v-if="canConfirm">
        <vl-button mod-large :mod-loading="confirmSending" :mod-disabled="viewingAsImpersonatedUser" @click="confirm">
            Bevestig ontvangst
        </vl-button>
    </template>
    <!-- /Confirm reception -->

    <!-- Answer -->
    <template v-else-if="(isStateConfirmed || isStateConfirmedUploadedImkl || isStateConfirmedInvalidImkl) && !isArchived && isUnaWriter">
        <!-- Loading  -->
        <template v-if="isProcessing && !isValidating && !showUpload">
            <vl-region>
                <vl-layout>
                    <div v-vl-align:center>
                        <vl-loader message="De gegevens worden geladen. Even geduld, a.u.b."/>
                    </div>
                </vl-layout>
            </vl-region>
        </template>
        <!-- Show Imkl upload -->
        <template v-if="showUpload">
            <!-- Show Imkl upload in new upload or in Validating state -->
            <kl-upload-imkl
                @revert="cancelUpload"
                :imklUploadUrl="imklUploadUrl"
                :isValidating="isValidating"
                :isImklTest="false"
                :mod-disabled="viewingAsImpersonatedUser"
                mod-revertable
                mod-bordered
            />
        </template>
        <!-- Show response actions -->
        <template v-else>
            <!-- Invalid Imkl uploaded -->
            <template v-if="isStateConfirmedInvalidImkl">
                <vl-alert mod-error icon="alert-circle" title="Uw pakket is niet gevalideerd">
                    <vl-typography>
                        Uw pakket voldoet niet aan de <a :href="imklRequirementsLink" target="_blank">IMKL-vereisten</a>.
                    </vl-typography>
                    <vl-action-group>
                        <vl-button icon="text-redo"
                                   @click="replaceIMKL"
                                   :mod-disabled="viewingAsImpersonatedUser || notInvolvedSending"
                                   mod-icon-before>
                            IMKL-pakket vervangen
                        </vl-button>
                        <vl-button :mod-disabled="viewingAsImpersonatedUser || notInvolvedSending"
                                   mod-tertiary
                                   @click="notInvolved">
                            Ik heb geen kabels en leidingen in deze zone
                        </vl-button>
                    </vl-action-group>
                </vl-alert>
                <kl-steps v-if="validationSteps" :steps="validationSteps"/>
            </template>

            <!-- Imkl not yet uploaded or Imkl uploaded but validating -->
            <template v-if="isStateConfirmed || isStateConfirmedUploadedImkl">
                <!-- Answer -->
                <template v-if="canAnswer">
                    <vl-title tag-name="h2" tag-style="h3">Kies uw antwoord</vl-title>
                    <vl-action-group>
                        <vl-button :mod-disabled="viewingAsImpersonatedUser || notInvolvedSending"
                                   mod-large
                                   @click="prepareImklUpload">
                            IMKL-pakket opladen
                        </vl-button>
                        <vl-button :mod-disabled="viewingAsImpersonatedUser || notInvolvedSending"
                                   mod-large
                                   mod-tertiary
                                   @click="notInvolved">
                            Ik heb geen kabels en leidingen in deze zone
                        </vl-button>
                    </vl-action-group>
                </template>
            </template>

        </template>
        <!-- End response actions -->

    </template>
    <!-- /Answer -->

    <!-- NotInvolved -->
    <template v-else-if="isStateNotInvolved">
        <vl-alert mod-success icon="check" title="Planaanvraag beantwoord">
            <vl-typography>
                U antwoordde <span v-if="hasDateLastStatusChange">op {{ dateLastStatusChange }}&nbsp;</span>dat u geen kabels en leidingen in de planaanvraagzone beheert.
                <template v-if="isArchived">Deze planaanvraag is
                    intussen gearchiveerd.
                </template>
                <br>
                Toch foutieve of onvolledige info doorgestuurd? Contacteer dan rechtstreeks de planaanvrager.
            </vl-typography>
            <vl-u-spacer mod-small/>
            <kl-una-maprequest-archive-download v-if="isArchived" v-slot:actions :maprequest-id="mapRequestId"
                                                :zone-id="zoneId" :download-url="downloadArchiveUrl"/>
        </vl-alert>
    </template>
    <!-- /NotInvolved -->

    <!-- isStateResponded -->
    <template v-else-if="isStateResponded">
        <vl-alert mod-success icon="check" title="Planaanvraag beantwoord">
            <template v-if="!isArchived">
                <vl-typography>
                    U antwoordde <span v-if="hasDateLastStatusChange">op {{ dateLastStatusChange }}&nbsp;</span>met
                    <vl-link :href="downloadImklUrl">dit IMKL-pakket</vl-link>
                    .
                    <template v-if="!mapAssetsReady">
                        <br>
                        Vanaf dat het plannenpakket beschikbaar is voor de planaanvrager, kan u hier uw antwoord op kaart bekijken.
                    </template>
                    <br>
                    Toch foutieve of onvolledige info doorgestuurd? Contacteer dan rechtstreeks de planaanvrager.
                </vl-typography>
                <vl-u-spacer mod-small/>
                <vl-action-group>
                    <vl-button v-if="mapAssetsReady" @click="navigateToViewer">
                        Bekijk uw antwoord voor deze zone op kaart
                    </vl-button>
                    <vl-button v-if="mapAssetsReady" @click.prevent="fetchDownloadKlipPackageUrl" mod-secondary>
                        Download .klip-bestand
                    </vl-button>
                </vl-action-group>
            </template>
            <template v-else>
                <vl-typography>
                    U antwoordde <span v-if="hasDateLastStatusChange">op {{ dateLastStatusChange }}&nbsp;</span>met een IMKL-pakket. Deze planaanvraag is intussen gearchiveerd.
                </vl-typography>
            </template>
            <kl-una-maprequest-archive-download v-if="isArchived" v-slot:actions :maprequest-id="mapRequestId"
                                                :zone-id="zoneId" :download-url="downloadArchiveUrl"/>
        </vl-alert>
    </template>
    <!-- /isStateResponded -->

    <template v-else-if="isStateNotAnswered && !isArchived">
        <vl-alert mod-error icon="alert-circle" title="Te laat!">
            <vl-typography>
                U bent al meer dan een maand te laat om deze planaanvraag te beantwoorden. U kan niet meer antwoorden via KLIP.
                <br/>
                Contacteer zo snel mogelijk de planaanvrager om de plannen rechtstreeks te bezorgen.
            </vl-typography>
        </vl-alert>
    </template>

    <template v-else-if="isStateShouldRespondToMri">
        <vl-alert mod-success icon="check" title="Planafhandeling rechtstreeks">
            <vl-typography v-if="!isArchived">
                De planaanvraag wordt rechtstreeks afgehandeld.
            </vl-typography>
            <vl-typography v-else>
                De planaanvraag werd rechtstreeks afgehandeld. Deze is intussen gearchiveerd.
            </vl-typography>
            <kl-una-maprequest-archive-download v-if="isArchived" v-slot:actions :maprequest-id="mapRequestId"
                                                :zone-id="zoneId" :download-url="downloadArchiveUrl"/>
        </vl-alert>
    </template>

    <template v-else-if="(isStateAssigned || isStateNotAnswered || isStateConfirmed) && isArchived">
        <vl-alert mod-error icon="alert-circle" title="Te laat!">
            <vl-typography>
                U was meer dan een maand te laat om deze planaanvraag te beantwoorden. Deze planaanvraag is intussen gearchiveerd.
            </vl-typography>
            <kl-una-maprequest-archive-download v-if="isArchived" v-slot:actions :maprequest-id="mapRequestId"
                                                :zone-id="zoneId" :download-url="downloadArchiveUrl"/>
        </vl-alert>
    </template>
</div>
